import {
  ADMIN_CLIENTS_GET_ALL_REQUESTING,
  ADMIN_CLIENTS_GET_ALL_SUCCESS,
  ADMIN_CLIENTS_GET_ALL_ERROR,
  ADMIN_SET_FAKE_DATA
} from "./constants";

export const getAllClientsRequest = payload => {
  return {
    type: ADMIN_CLIENTS_GET_ALL_REQUESTING,
    payload
  };
};

export const setFakeData = payload => {
  return {
    type: ADMIN_SET_FAKE_DATA,
    payload
  };
};
